import { useDeleteWorkPackageMutation } from "@common/api/work-packages"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/work-orders/_list/delete/$workOrderId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "work_package:delete", "/"),
  component: DeleteWorkOrderDialog,
})

function DeleteWorkOrderDialog(): React.ReactElement {
  const { workOrderId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteWorkPackageMutation()

  const close = () => navigate({ to: "/work-orders", search: true })

  return (
    <DeleteDialog
      noun="work order"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { id: workOrderId },
          {
            onSuccess: () => {
              showToast("Deleted", "Work order deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
